// extracted by mini-css-extract-plugin
export default {"leftPanelTabs":"LeftPanel_leftPanelTabs__ZaSNr"};